const OPEN_CLASS = 'accordion_open';

class JollyAccordion extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.header = this.querySelector('.jc-accordion__header');
    this.contentWrapper = this.querySelector('.jc-accordion__content-wrapper');
    this.content = this.querySelector('.jc-accordion__content');

    if (!this.header || !this.contentWrapper || !this.content) return;

    this.onToggle = this.onToggle.bind(this);
    this.header.addEventListener('click', this.onToggle);
    this.header.addEventListener('keydown', this.onToggle);

    if (!this.header.hasAttribute('role')) {
      this.header.setAttribute('role', 'button');
    }

    if (!this.header.hasAttribute('tabindex')) {
      this.header.setAttribute('tabindex', '0');
    }

    if (this.hasAttribute('data-accordion-open') || this.classList.contains(OPEN_CLASS)) {
      this.openAccordion();
    } else {
      this.closeAccordion();
    }

    this.initialized = true;
  }

  disconnectedCallback() {
    if (!this.header || !this.onToggle) return;

    this.header.removeEventListener('click', this.onToggle);
    this.header.removeEventListener('keydown', this.onToggle);
    this.initialized = false;
  }

  onToggle(event) {
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;

    event.preventDefault();

    if (this.isOpen()) {
      this.closeAccordion();
      return;
    }

    this.closeSiblingAccordions();
    this.openAccordion();
  }

  isOpen() {
    return this.classList.contains(OPEN_CLASS);
  }

  openAccordion() {
    this.classList.add(OPEN_CLASS);
    this.header?.setAttribute('aria-expanded', 'true');
    this.updateHeight();
  }

  closeAccordion() {
    this.classList.remove(OPEN_CLASS);
    this.header?.setAttribute('aria-expanded', 'false');

    if (this.contentWrapper) {
      this.contentWrapper.style.height = '0px';
    }
  }

  updateHeight() {
    if (!this.contentWrapper || !this.content) return;

    this.contentWrapper.style.height = `${this.content.scrollHeight}px`;
  }

  closeSiblingAccordions() {
    const wrapper = this.closest('.jc-accordion-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('jolly-accordion').forEach((accordion) => {
      if (accordion !== this && typeof accordion.closeAccordion === 'function') {
        accordion.closeAccordion();
      }
    });
  }
}

const updateOpenAccordions = () => {
  document.querySelectorAll('jolly-accordion').forEach((accordion) => {
    if (typeof accordion.updateHeight === 'function' && accordion.isOpen()) {
      accordion.updateHeight();
    }
  });
};

if (!customElements.get('jolly-accordion')) {
  customElements.define('jolly-accordion', JollyAccordion);
}

window.addEventListener('load', updateOpenAccordions);
window.addEventListener('resize', updateOpenAccordions);
document.addEventListener('shopify:section:load', updateOpenAccordions);
